import { useEffect } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { FxGetCustomerIDResType } from '../types/ResponseTypes';
import type { FxGetCustomerIDReqType } from '../types/ResquestTypes';

const getCustomerId = (
  payload: FxGetCustomerIDReqType
): Promise<BaseResponse<FxGetCustomerIDResType, FxGetCustomerIDReqType>> => {
  return axios<
    FxGetCustomerIDReqType,
    BaseResponse<FxGetCustomerIDResType, FxGetCustomerIDReqType>,
    FxGetCustomerIDReqType
  >({
    url: `/fx/customers/${payload.customerId}`,
    method: 'get',
  });
};

export const useGetCustomerId = (payload: FxGetCustomerIDReqType) => {
  const { data, isLoading, isSuccess, error } = useQuery({
    queryKey: ['getFxCustomerId'],
    queryFn: () => getCustomerId(payload),
    useErrorBoundary: false,
    enabled: payload.customerId !== '',
  });

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { fxCustomerId: data?.data.data.fxCustomerId, isLoading, isSuccess };
};
